module.exports = __webpack_public_path__ + "media/images/lp_chintai/sec06_img_01-8ebdbaa70493e80e9443952fbd7e6972.png";